import { render } from "./About.vue?vue&type=template&id=736826e3&scoped=true"
import script from "./About.ts?vue&type=script&lang=js"
export * from "./About.ts?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=736826e3&lang=scss&scoped=true"

import exportComponent from "/Users/lucatescari/Documents/Projects/Private/rt-songpage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736826e3"]])

export default __exports__